import { friendlyError } from "../../../lib/friendlyError";
import { trpc } from "../../../trpc";
import { TestThenSend } from "../TestThenSend";
import {
  EMAIL_OFF_SENTENCE,
  people,
  SEND_OFFLINE_SENTENCE,
  sendAllSentence,
} from "../sendCopy";
import { BODY_TEXT } from "../ui";
import { useSendFlow } from "../useSendFlow";

/**
 * But, why? on the day: the run of the evening (doors, the live podcast,
 * a short meditation, dinner) to everyone who booked. Walk-ins don't get
 * it; they're registered at the door.
 */
export function TonightPanel({
  audienceCount,
  defaultTestEmail,
  senderName,
  alreadySentNote,
}: {
  audienceCount: number;
  defaultTestEmail: string;
  senderName: string | null;
  alreadySentNote: string | null;
}) {
  const flow = useSendFlow(defaultTestEmail);
  const utils = trpc.useUtils();
  const tonight = trpc.adminSendButWhyTonight.useMutation();

  const send = (mode: "test" | "all") => {
    tonight.mutate(
      {
        mode,
        testEmail: mode === "test" ? flow.testAddress.trim() : undefined,
        testName: mode === "test" ? (senderName ?? undefined) : undefined,
      },
      {
        onSuccess: (res) => {
          if (res.mode === "test") {
            flow.testSent(
              res.skipped
                ? EMAIL_OFF_SENTENCE
                : `Test sent to ${res.sentTo}. Read it through, then send to everyone who booked.`,
            );
          } else if (res.mode === "all") {
            flow.sendAllDone(
              sendAllSentence(
                res,
                "No one who booked has an email address, so nothing was sent.",
              ),
            );
            void utils.adminListEmailSends.invalidate();
          }
        },
        onError: (err) =>
          flow.problem(friendlyError(err, SEND_OFFLINE_SENTENCE)),
      },
    );
  };

  return (
    <>
      <p className={BODY_TEXT}>
        Tells everyone who booked how tonight runs: doors at 6:30, the live
        podcast from 6:50, a short meditation at 8:00 and dinner from 8:20, with
        the venue again. Best sent the morning of the event.
      </p>
      <TestThenSend
        flow={flow}
        emailName="Tonight (how the evening runs)"
        audience={audienceCount > 0 ? people(audienceCount) : null}
        noAudienceText="No one who booked has an email address yet, so there's no one to send this to."
        busy={tonight.isPending}
        onSendTest={() => send("test")}
        onSendAll={() => send("all")}
        alreadySentNote={alreadySentNote}
      />
    </>
  );
}
